import { CASHFREE_MODE } from "../../config/apiConfig";

export function loadCashfreeScript() {
  return new Promise(function (resolve, reject) {
    if (typeof window !== "undefined" && window.Cashfree) {
      resolve(window.Cashfree);
      return;
    }
    var s = document.createElement("script");
    s.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    s.onload = function () {
      if (window.Cashfree) resolve(window.Cashfree);
      else reject(new Error("Cashfree SDK failed to load"));
    };
    s.onerror = function () {
      reject(new Error("Cashfree SDK unavailable"));
    };
    document.head.appendChild(s);
  });
}

export async function launchCashfreeCheckout(paymentSessionId, returnUrl) {
  var Cashfree = await loadCashfreeScript();
  var mode = CASHFREE_MODE === "sandbox" ? "sandbox" : "production";
  var cf = Cashfree({ mode: mode });
  return cf.checkout({
    paymentSessionId: paymentSessionId,
    returnUrl: returnUrl,
  });
}

export default { loadCashfreeScript, launchCashfreeCheckout };
